import { useContext, useState, useMemo, useEffect } from "react";
import Header from "../Components/layout/Header.js";
import SorTableCheckable from "../Components/ui/sortable-checkable.js";
import { Context } from "../App.js";
import { IconButton, TableCell, Box, Typography, TextField, Dialog, MenuItem, Menu, InputAdornment, Stack, Button, Backdrop, CircularProgress, List, ListItem, Divider } from "@mui/material";
import { Delete, Edit, InfoOutlined, Search, Close, MoreVert } from "@mui/icons-material";
import { API } from "../conf.js";
import moment from "moment";
import AlerteForm from "../AdmComponents/forms/alerte-form.js";

export default function AlerteManager() {
    const { updateConnect } = useContext(Context)
    const alerte_types = ['Information', 'Avertissement', 'Erreur']
    const table = [
        {header: "Type", sortable: true, sortBy:(el)=>el.level, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{alerte_types[row.level-1]}</TableCell>},
        {header: "Titre", sortable: true, sortBy:(el)=>el.title.toLowerCase(), row: (row, index)=><TableCell key={index} style={{minWidth:'120px'}}>{row.title}</TableCell>},
        {header: "Message", sortable: false, row: (row, index)=><TableCell key={index}>{row.message}</TableCell>},
        {header: "Status", sortable: true, sortBy:(el)=>el.is_active, row: (row, index)=><TableCell key={index}><Button color={row.is_active? 'primary' : 'carmine'} onClick={()=>switchStatus(row._id)}>{row.is_active?'active':'inactive'}</Button></TableCell>},
        {header: "Date", sortable: true, sortBy:el=>el.start_time? new Date(el.start_time).getTime() : '', row: (row, index)=><TableCell key={index} style={{minWidth:'70px'}}>{row.start_time? moment(row.start_time).format('DD-MM-yyyy')+(row.end_time?(' au '+moment(row.end_time).format('DD-MM-yyyy')):'') : ''}</TableCell>},
        {header: "Églises", sortable: false, row: (row, index)=><TableCell key={index}>{row.eglises?.length===1?eglises.find(eg=>row.eglises.includes(eg.number))?.nom:row.eglises?.length}</TableCell>},
        {header: "Auteur", sortable: true, sortBy:(el)=>(el.autor?.nom+' '+el.autor?.prenom1+' '+el.autor?.prenom2).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', textAlign:'center'}}>{Boolean(row.autor)?(row.autor?.nom+' '+row.autor?.prenom1+' '+row.autor?.prenom2):''}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'110px'}} >
            <IconButton aria-label="modifier" onClick={()=>{setAlert(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="informations complémentaires" onClick={()=>{setAlert(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" disabled={agent._id===row._id} onClick={()=>{setAlert(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>
        </TableCell>}
    ]

    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseNum, setEgliseNum] = useState('')

    const [load, setLoad] = useState(false)
    const [alerts, setAlerts] = useState([])
    const [alert, setAlert] = useState()
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')

    const [anchorEl, setAnchorEl] = useState(null);

    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el.number===egliseNum), [egliseNum, eglises, organisation])

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.title+' '+item.message
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        if (!status) {
            setAlert()
        } 
    }

    async function handleDelete(alerts) {
        setLoad(true)
        fetch(API.concat('/alerts'), {method:'DELETE', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({_id: {$in: alerts}})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setAlerts(old=> old.filter(alt=>!alerts.includes(alt._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    async function switchStatus(alertId){
        setLoad(true);
        fetch(API.concat('/alerts/'+alertId+'/status'), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const updatedAlert = await response.json()
                    setAlerts(old=> old.map(alt=> alt._id === updatedAlert._id ? updatedAlert : alt))
                }
                setLoad(false)
            }
        })
    }

    async function switchMassStatus(alertesIds, status=true) {
        setLoad(true);
        fetch(API.concat('/alerts/status'), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify({alertesIds, status})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    setAlerts(old=> old.map(alt=> alertesIds.includes(alt._id) ? {...alt, is_active: status} : alt))
                }
                setLoad(false)
            }
        })
    }

    function getAllAlertes() {
        setLoad(true);
        fetch(API.concat('/alerts'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {alerts, users} = await response.json()
                    
                    Promise.all(alerts.map(alert=>{return new Promise((resolve, reject) => {
                        alert.autor = users.find(e=> e.num===alert.autor)
                        resolve(alert)
                    })})).then(alerts=>{
                        setAlerts(alerts); setLoad(false)
                    })
                }else setLoad(false)
            }
        })
    }

    async function getAlertsByEglise(egliseNumber) {
        setLoad(true);
        const query = new URLSearchParams({eglises: egliseNumber}).toString()
        fetch(API.concat('/alerts/by?'+query), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const alerts = await response.json()
                    setAlerts(alerts); 
                }
                setLoad(false)
            }
        })
    }

    async function handleEglise(value) {
        setEgliseNum(value)
        if (value&&value==='tous') {
            getAllAlertes()
        } else {
            getAlertsByEglise(value)
        }
    }

    useEffect(()=>{
        if(organisation) {
            setLoad(true)
            if(organisation.type==='fédération') {
                fetch(API.concat(`/eglises/by`), {
                    method:'POST',
                    headers:{
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                    }, body: JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:agent.level>=4?{type: {$in: ['église', 'fédération']}}:{type:'église'})
                }).then(async(response) => {
                    const token = response.headers.get('x-auth-token')
                    if(response.status === 401) {
                        sessionStorage.clear()
                        updateConnect(false)
                    }else {
                        if (token && token !== sessionStorage.getItem('token') && token !== '') {
                            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                        }
                        if (response.status === 200) {
                            const json = await response.json()
                            setEglises(json)
                        }
                        setLoad(false)
                    }
                })
            } else {
                setEglises([organisation])
                getAlertsByEglise(organisation.number)
            }
        }
    }, [organisation, agent])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[]) 

    return(
        <Box>
            <Header/>
            <Typography variant="h4" align="center" marginBlock={3}>Gestion des alertes</Typography>
            <Box display='flex' flexDirection='column' paddingInline={3}>
                {organisation&&organisation.type==='fédération'&&
                <TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseNum} 
                onChange={e=>handleEglise(e.target.value)}>
                    {eglises.length>1&&<MenuItem value={'tous'}>INDIFFÉRENT</MenuItem>}
                    {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(eglise=>
                        <MenuItem key={eglise._id} value={eglise.number}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>
                    )}
                </TextField>}

                {(eglise||egliseNum==='tous')&&
                <Box display='flex' columnGap={2} alignItems='center' mb={2}>
                    <Stack direction='row' spacing={1} alignItems='center' sx={{flexGrow:1}}>
                        {/* <TextField select size="small" label="Action de masse" disabled={selectItems.length<=0} 
                        sx={{width:'20%', minWidth:'200px'}} SelectProps={{native: true}}>
                            <option value="">Choisissez une action</option>
                            <option value="delete many" onClick={()=>handleDelete(selectItems)}>supprimer</option>
                            <option value="activate">activer</option>
                            <option value="deactivate">désactiver</option>
                        </TextField> */}

                        <Button
                        variant="contained"
                        disabled={selectItems.length <= 0}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        startIcon={<MoreVert />}
                        >
                            Actions de masse
                        </Button>
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                            <MenuItem onClick={() => {setAnchorEl(null); handleDelete(selectItems)}}>Supprimer</MenuItem>
                            <MenuItem onClick={() => {setAnchorEl(null); switchMassStatus(selectItems)}}>Activer</MenuItem>
                            <MenuItem onClick={() => {setAnchorEl(null); switchMassStatus(selectItems, false)}}>Désactiver</MenuItem>
                        </Menu>

                        <TextField placeholder="Rechercher une alerte" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                        InputProps={{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}/>
                    </Stack>

                    <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>Créer</Button>
                </Box>}

                <SorTableCheckable {...{table, data:alerts.filter(el=>normalize(get_searchable(el)).includes(normalize(search))), selectItems, setItems, rowsPerPage:50, rowsPerPageOptions:[25, 50, 100, 300]}}/>
            </Box>

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={['add', 'edit'].includes(action)?'md': action==='info'?'sm':'xs'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                
                {action==='info'&& <Box display='flex' flexDirection='column' marginX='20px' marginBottom='20px'>
                    <Typography variant="h6" align="center" marginBottom='10px' style={{textTransform:'capitalize'}}>{alert.title}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Type:</span> {alerte_types[alert.level-1]}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Status:</span> {alert.is_active? 'active' : 'inactive'}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Auteur:</span> {alert.autor.prenom1} {alert.autor.nom}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Créée le:</span> {moment(alert.createdAt).format('DD-MM-yyyy HH:mm')}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Période:</span> {alert.start_time? moment(alert.start_time).format('DD-MM-yyyy')+(alert.end_time?(' au '+moment(alert.end_time).format('DD-MM-yyyy')):'') : ''}</Typography>
                    <Typography variant="body1" marginTop='5px'><span style={{fontWeight:'bold'}}>Message:</span> {alert.message}</Typography>
                    <Divider sx={{alignSelf:'center', width:'40%', my:2}}/>
                    {alert.eglises.length>0&&<Typography variant="subtitle1" marginTop='5px'>Églises concernées: </Typography>}
                    <List>
                        {eglises.filter(eglise=>alert.eglises.includes(eglise.number)).length===0&&<Typography marginLeft='20px'>Aucune église trouvée</Typography>}
                        {eglises.filter(eglise=>alert.eglises.includes(eglise.number)).map(eglise=><Typography key={eglise._id} marginLeft='20px' textTransform='capitalize'>• {eglise.nom+' - '+eglise.commune}</Typography>)}
                    </List>
                </Box>}

                {action==='add'&& <AlerteForm {...{eglises, add:alt=>{if(egliseNum==='tous'||alt.eglises.map(eg=>eg.number).includes(eglise.number))setAlerts(old=>[...old, alt])}, close:()=>manage_dialog(false, '')}} />}
                {action==='edit'&&alert&& <AlerteForm {...{eglises, edit:true, alert, add:alt=>setAlerts(old=>[...old.filter(u=>u._id!==alt._id), (egliseNum==='tous'||alt.eglises.map(eg=>eg.number).includes(eglise?.number))?alt:''].filter(us=>us!=='')), close:()=>manage_dialog(false, '')}} />}

                {action==='delete'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center" >Confirmez-vous la suppression de l'alerte "{alert.title}"</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete([alert._id])}>supprimer</Button>
                    </Stack>
                </Box>}
                
                {action==='delete many'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Confirmez-vous la suppression de {selectItems.length} alerte{selectItems.length>1&&'s'}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete(selectItems)}>supprimer</Button>
                    </Stack>
                </Box>}
            </Dialog>
        </Box>
    )
}